import React from "react";
import AboutUploader from "../component/aboutUploader";

const About = () => {
  return (
    <div className="about-page ">
      <AboutUploader />
    </div>
  );
};

export default About;
